"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initRecordIds = initRecordIds;
function initRecordIds() {
    const recordIds = new WeakMap();
    let nextId = 1;
    return {
        getIdForEvent(event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map